const transferAmount = {
    "d": {
        IsSuccess: true
    }
};
export default transferAmount;